module.exports = {
  NAVY_BLUE_ORIGIN: '#2D3F86',
  NAVY_BLUE_SOFT: '#DEE5FE',
  NAVY_BLUE_LIGHT: '#7792FB',
  NAVY_BLUE_BRIGHT: '#4767E1',
  NAVY_BLUE_DARK: '#1B2A66',

  GOLD_LIGHT: '#FACC65',
  GOLD_BRIGHT: '#C6984E',
  GOLD_ORIGIN: '#BF7E3E',
  GOLD_DEEP: '#B75147',
  RED_ORIGIN: '#F60303',

  BLUE_SOFT: '#F3FBFF',
  BLUE_LIGHT: '#D4F0FF',
  BLUE_BRIGHT_1: '#6CCAFF',
  BLUE_BRIGHT_2: '#65BAEA',
  BLUE_ORIGIN_1: '#00A3FF',
  BLUE_ORIGIN_2: '#0395E8',
  BLUE_DARK_1: '#0082CC',
  BLUE_DARK_2: '#0372B0',

  GREEN_LIGHT: '#DCFFE4',
  GREEN_ORIGIN: '#00E033',
  GREEN_DARK: '#02C92F',

  GRAY_LIGHT_1: '#FAFAFA',
  GRAY_LIGHT_2: '#F9F9F9',
  GRAY_LIGHT_3: '#F5F5F5',
  GRAY_LIGHT_4: '#F0F0F0',
  GRAY_LIGHT_5: '#EBEBEB',

  GRAY_BRIGHT_1: '#C4C4C4',
  GRAY_BRIGHT_2: '#CCCCCC',
  GRAY_BRIGHT_3: '#AAAAAA',

  GRAY_ORIGIN_1: '#999999',
  GRAY_ORIGIN_2: '#878787',
  GRAY_ORIGIN_3: '#777777',

  GRAY_STRONG_1: '#666666',
  GRAY_STRONG_2: '#555555',
  GRAY_STRONG_3: '#444444',

  WHITE: '#FFFFFF',
  BLACK: '#000000',
  DEFAULT_TEXT: '#202020',

  BOX_SHADOW: 'rgba(0, 0, 0, 0.24)', // BoxShadow Color
};
